import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) {
    return null; // No mostrar paginación si solo hay una página o menos
  }

  return (
    <div className="mt-8 flex justify-center items-center gap-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        className="bg-gray-300 px-4 py-2 rounded-lg font-bold hover:bg-gray-400 disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={currentPage === 1}
      >
        Anterior
      </button>
      <span className="font-semibold">
        Página {currentPage} de {totalPages}
      </span>
      <button
        onClick={() => onPageChange(currentPage + 1)}
        className="bg-gray-300 px-4 py-2 rounded-lg font-bold hover:bg-gray-400 disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={currentPage === totalPages}
      >
        Siguiente
      </button>
    </div>
  );
};

export default Pagination;
